<template>
    <div class="section px-0 pt-0">
        <div class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <h1 class="title has-text-weight-bold is-size-5">
                        {{ name }} ({{ projects.length }})
                    </h1>
                </div>
            </div>

            <div v-if="projects.length > 3 && !expanded" class="level-right">
                <div class="level-item">
                    <a
                        v-t="'Explorer.view_all'"
                        class="has-text-grey"
                        @click="$emit('update:selected', !selected)"
                    ></a>
                </div>
            </div>
        </div>

        <div :class="{ 'is-multiline': expanded }" class="columns is-mobile">
            <div
                v-for="item in projectsSample"
                :key="item._id"
                :to="{ name: 'project', params: { projectId: item._id } }"
                class="column is-12-mobile is-6-tablet is-4-widescreen"
                @click="$emit('click', item)"
            >
                <project-card :content="item" />
            </div>
        </div>
    </div>
</template>

<script>
import ProjectCard from '@/components/ProjectCard';
export default {
    components: {
        ProjectCard,
    },
    props: {
        name: {
            type: String,
            default: '',
            required: false,
        },
        filter: {
            type: String,
            default: '',
            required: false,
        },
        selected: {
            type: Boolean,
            default: false,
            required: false,
        },
        projects: {
            type: Array,
            default: () => {
                return [];
            },
        },
        expanded: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    computed: {
        projectsSample() {
            let projectsProcessed = this.projects.filter((project) => {
                if (
                    this.filter ===
                    this.$t('Constants.FILTER_OPTION_PROJECTS_COLLECTIONS')
                ) {
                    return project.type == 'collection';
                } else if (
                    this.filter ===
                    this.$t('Constants.FILTER_OPTION_PROJECTS_GAMES')
                ) {
                    return project.type != 'collection';
                } else {
                    return true;
                }
            });
            if (!this.expanded) {
                return projectsProcessed.slice(0, 3);
            }
            return projectsProcessed;
        },
    },
};
</script>

<style></style>
